<template>
  <div>
    <section v-if="detailVal">
      <h2>{{ "项目：" + detailVal.project_name }}</h2>
      <div>
        <p>甲方/元</p>
        <p>员工/元</p>
      </div>
      <ul>
        <li>
          <h3>一、双周价格</h3>
        </li>
        <li>
          <label>单卫：</label>
          <span>{{ Number(detailVal.double_one_three) }}</span>
          <span>{{ Number(detailVal.double_one_guard) }}</span>
        </li>
        <li>
          <label>双卫：</label>
          <span>{{ Number(detailVal.double_two_three) }}</span>
          <span>{{ Number(detailVal.double_two_guard) }}</span>
        </li>
        <li>
          <label>三卫：</label>
          <span>{{ Number(detailVal.double_three_three) }}</span>
          <span>{{ Number(detailVal.double_three_guard) }}</span>
        </li>
        <li>
          <h3>二、退租价格</h3>
        </li>
        <li>
          <label>单间：</label>
          <span>{{ Number(detailVal.quit_one_three) }}</span>
          <span>{{ Number(detailVal.quit_one_guard) }}</span>
        </li>
        <li>
          <label>独卫：</label>
          <span>{{ Number(detailVal.quit_single_three) }}</span>
          <span>{{ Number(detailVal.quit_single_guard) }}</span>
        </li>
        <li>
          <label>公共区域：</label>
          <span>{{ Number(detailVal.quit_common_three) }}</span>
          <span>{{ Number(detailVal.quit_common_guard) }}</span>
        </li>
        <li>
          <h3>三、深度价格</h3>
        </li>
        <li>
          <label>深度：</label>
          <span>{{ Number(detailVal.depth_three) }}</span>
          <span>{{ Number(detailVal.depth_guard) }}</span>
        </li>
        <li>
          <h3>四、开荒价格</h3>
        </li>
        <li>
          <label>1室：</label>
          <span>{{ Number(detailVal.open_one_three) }}</span>
          <span>{{ Number(detailVal.open_one_guard) }}</span>
        </li>
        <li>
          <label>2室：</label>
          <span>{{ Number(detailVal.open_two_three) }}</span>
          <span>{{ Number(detailVal.open_two_guard) }}</span>
        </li>
        <li>
          <label>3室：</label>
          <span>{{ Number(detailVal.open_three_three) }}</span>
          <span>{{ Number(detailVal.open_three_guard) }}</span>
        </li>
        <li>
          <label>4室：</label>
          <span>{{ Number(detailVal.open_four_three) }}</span>
          <span>{{ Number(detailVal.open_four_guard) }}</span>
        </li>
        <li>
          <label>5室：</label>
          <span>{{ Number(detailVal.open_five_three) }}</span>
          <span>{{ Number(detailVal.open_five_guard) }}</span>
        </li>
        <li>
          <label>6室：</label>
          <span>{{ Number(detailVal.open_six_three) }}</span>
          <span>{{ Number(detailVal.open_six_guard) }}</span>
        </li>
      </ul>
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      detailVal: {}
    };
  },
  props: {
    detail: {}
  },
  watch: {
    detail() {
      this.detailVal = this.detail;
      console.log(this.detail);
    }
  }
};
</script>
<style lang="less" scoped>
section {
  margin: 30px 3%;
  h2 {
    line-height: 24px;
    font-size: 16px;
    font-weight: normal;
    margin: 10px 0 30px 100px;
  }
  > div {
    margin-left: 80px;
    > p {
      display: inline-block;
      min-width: 100px;
      margin-right: 30px;
    }
  }
  > ul {
    padding-bottom: 30px;
    > li {
      margin-bottom: 10px;
      > label {
        display: inline-block;
        // margin-left: 30px;
        width: 70px;
        text-align: right;
      }
      > h3 {
        font-size: 14px;
        line-height: 20px;
        margin-top: 20px;
        font-weight: normal;
      }
      > span {
        display: inline-block;
        font-size: 14px;
        border: 1px solid #ddd;
        padding: 6px 10px;
        min-width: 100px;
        margin-right: 30px;
        border-radius: 4px;
      }
    }
  }
}
</style>
